<template>
   <div class="card m-3">
      <div class="card-header">
        <h2 align="left">CrissCross Analysis</h2>
        </div>
      <div class="card-body">
        <!--            :renderers=renderers-->
        <vue-pivottable-ui
            v-model="config"
            :data="data"
            :localeStrings="localeStrings[locale]"
            :rendererName="rendererName"
            :renderers="renderers"
            :aggregatorName="aggregatorName"
            :aggregators="aggregators"
            :tableColorScaleGenerator="colorScaleGenerator"
            :attributes="attributes"
            :valueFilter="valueFilter"
            :rows="rows"
            :cols="cols"
            :vals="vals"
            :disabledFromDragDrop="disabledFromDragDrop"
            :sortonlyFromDragDrop="sortonlyFromDragDrop"
            :hiddenFromDragDrop="hiddenFromDragDrop"
            :hiddenFromAggregators="hiddenFromAggregators"
            :sorters="sorters"
            rowOrder="value_a_to_z"
        >
          <colgroup slot="colGroup">
            <col :width="300">
            <col>
          </colgroup>
          <div v-if="loading" slot="output">
            loading...
          </div>
          <template v-if="!loading" slot="output" slot-scope="{ pivotData }">
            {{ pivotData }}
          </template>
          <template slot="pvtAttr" slot-scope="{ name }">
            {{ name }}
          </template>
        </vue-pivottable-ui>
        </div>
     </div>
</template>

<script>
import {PivotUtilities, Renderer, VuePivottableUi} from 'vue-pivottable'

import 'vue-pivottable/dist/vue-pivottable.css'
import {scaleLinear} from 'd3-scale'
import axios from "axios";

export default {
  components: {
    VuePivottableUi
    // VuePivottable
  },
  name: 'app',
  data () {
    return {
      // fix issue #27
      valueFilter: {
        Meal: {
          Dinner: true
        }
      },
      config: {},
      filteredData: [],
      data: [],
      //attributes: ['Retailer', 'Retailer Type', 'Territory', 'Salesperson', 'Product Category', 'Product Subcategory', 'Product Family', 'Product', 'Brand', 'Year-Month', 'Year-Quarter', 'Transactions', 'Units', 'Cost Amount', 'Sales Amount'],
      attributes: ['channel', 'dealer_policy', 'prod_category', 'state_name', 'metro_nonmetro', 'fy_year', 'fy_month', 'rev_cy_ftm', 'rev_cy_ytd', 'ftm_yoy%', 'revenue_goly'],
      rows: ['state_name'],
      cols: ['channel'],
      vals: ['rev_cy_ytd'],
      disabledFromDragDrop: [], // ['Payer Gender'],
      hiddenFromAggregators:['channel', 'dealer_policy', 'prod_category', 'state_name', 'metro_nonmetro', 'fy_name', 'fy_year', 'fy_month', ],
      hiddenFromDragDrop: ['rev_cy_ftm', 'rev_cy_ytd', 'ftm_yoy%', 'revenue_goly'],
      sortonlyFromDragDrop: [], // ['Party Size'],
      // pivotColumns: [],
      loading: false,
      aggregatorName: 'Sum',
      rendererName: 'Table',
      localeStrings: {
        en: {
          renderError: 'An error occurred rendering the PivotTable results.',
          computeError: 'An error occurred computing the PivotTable results.',
          uiRenderError: 'An error occurred rendering the PivotTable UI.',
          selectAll: 'Select All',
          selectNone: 'Select None',
          tooMany: 'too many values to show',
          filterResults: 'Filter values',
          totals: 'Totals',
          only: 'only',
          rendererNames: {
            Table: 'Table',
            'Table Heatmap': 'Table Heatmap',
            'Table Col Heatmap': 'Table Col Heatmap',
            'Table Row Heatmap': 'Table Row Heatmap',
            'Export Table TSV': 'Export Table TSV',
            'Grouped Column Chart': 'Grouped Column Chart',
            'Stacked Column Chart': 'Stacked Column Chart',
            'Grouped Bar Chart': 'Grouped Bar Chart',
            'Stacked Bar Chart': 'Stacked Bar Chart',
            'Line Chart': 'Line Chart',
            'Dot Chart': 'Dot Chart',
            'Area Chart': 'Area Chart',
            'Scatter Chart': 'Scatter Chart',
            'Multiple Pie Chart': 'Multiple Pie Chart'
          },
          aggregatorMap: {
            Count: 'Count',
            'Count Unique Values': 'Count Unique Values',
            'List Unique Values': 'List Unique Values',
            Sum: 'Sum',
            'Integer Sum': 'Integer Sum',
            Average: 'Average',
            Median: 'Median',
            'Sample Variance': 'Sample Variance',
            'Sample Standard Deviation': 'Sample Standard Deviation',
            Minimum: 'Minimum',
            Maximum: 'Maximum',
            First: 'First',
            Last: 'Last',
            'Sum over Sum': 'Sum over Sum',
            'Sum as Fraction of Total': 'Sum as Fraction of Total',
            'Sum as Fraction of Rows': 'Sum as Fraction of Rows',
            'Sum as Fraction of Columns': 'Sum as Fraction of Columns',
            'Count as Fraction of Total': 'Count as Fraction of Total',
            'Count as Fraction of Rows': 'Count as Fraction of Rows',
            'Count as Fraction of Columns': 'Count as Fraction of Columns'
          }
        }
      },
      locale: 'en'
    }
  },
  created () {
    setTimeout(() => {
      // this.data = tips
      axios({ url: '/json/forewarn_duroflex.json', baseURL: '', method: 'GET' }).then(res => {
     /* axios({ url: '/json/bank_data.json', baseURL: '', method: 'GET' }).then(res => {*/
        this.data= res.data
      })
    }, 1000)
  },
  computed: {
    sorters () {
      return {
        'Day of Week': PivotUtilities.sortAs(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'])
      }
    },
    unusedAttrs () {
      return this.config.unusedAttrs
    },

    renderers () {
      const TableRenderer = Renderer.TableRenderer
      // const PlotlyRenderer = Renderer.PlotlyRenderer
      return (() => ({
            'Table': TableRenderer.Table,
            'Heatmap': TableRenderer['Table Heatmap']/*,
            'Table Col Heatmap': TableRenderer['Table Col Heatmap'],
            'Table Row Heatmap': TableRenderer['Table Row Heatmap'],
            'Export Table TSV': TableRenderer['Export Table TSV']*/
          })
      )()
    },
    aggregators() {
      const usFmt = PivotUtilities.numberFormat()
      const usFmtInt = PivotUtilities.numberFormat({ digitsAfterDecimal: 0 })
      // const usFmtPct = PivotUtilities.numberFormat({
      //   digitsAfterDecimal: 1,
      //   scaler: 100,
      //   suffix: '%'
      // })
      return ((tpl) => ({
            'Count': tpl.count(usFmtInt),
           /* 'Count Unique Values': tpl.countUnique(usFmtInt),
            'List Unique Values': tpl.listUnique(', '),*/
            Sum: tpl.sum(usFmt),
           /* 'Integer Sum': tpl.sum(usFmtInt),*/
            'Average': tpl.average(usFmt), //,
            'Median': tpl.median(usFmt),
            // 'Sample Variance': tpl.var(1, usFmt),
            // 'Sample Standard Deviation': tpl.stdev(1, usFmt),
            // 'Minimum': tpl.min(usFmt),
            // 'Maximum': tpl.max(usFmt),
            // 'First': tpl.first(usFmt),
            // 'Last': tpl.last(usFmt),
            // 'Sum over Sum': tpl.sumOverSum(usFmt),
            // 'Sum as Fraction of Total': tpl.fractionOf(tpl.sum(), 'total', usFmtPct),
            // 'Sum as Fraction of Rows': tpl.fractionOf(tpl.sum(), 'row', usFmtPct),
            // 'Sum as Fraction of Columns': tpl.fractionOf(tpl.sum(), 'col', usFmtPct),
            // 'Count as Fraction of Total': tpl.fractionOf(tpl.count(), 'total', usFmtPct),
            // 'Count as Fraction of Rows': tpl.fractionOf(tpl.count(), 'row', usFmtPct),
            // 'Count as Fraction of Columns': tpl.fractionOf(tpl.count(), 'col', usFmtPct)
          })
      )(PivotUtilities.aggregatorTemplates)
    }
  },
  methods: {
    colorScaleGenerator (values) {
      const scale = scaleLinear()
          .domain([0, Math.max.apply(null, values)])
          .range(['#fff', '#77f'])
      return x => {
        return { 'background-color': scale(x) }
      }
    }
  },
  watch: {
    config: {
      handler (value) {
        const PivotData = PivotUtilities.PivotData
        // this.data = tips
        this.filteredData = new PivotData(value).getFilteredData()
      },
      deep: true,
      immediate: false
    }
  }
}
</script>

<style>
.main {
  max-width: 980px;
  margin: 8vh auto 20px;
}
.title {
  text-align: center;
  margin-bottom: 20px;
}
h1 {
  margin-bottom: 0px;
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
}
pre {
  text-align: left;
  background-color: #f8f8f8;
  padding: 1.2em 1.4em;
  line-height: 1.5em;
  margin: 60px 0 0;
  overflow: auto;
}
code {
  padding: 0;
  margin: 0;
}
footer {
  text-align: center;
  margin-top: 40px;
  line-height: 2;
}
</style>
